/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEnteDto } from '../../models/create-ente-dto';
import { EnteResDto } from '../../models/ente-res-dto';

export interface EntiControllerCreateEnte$Params {
  body: CreateEnteDto;
}

export function entiControllerCreateEnte(
  http: HttpClient,
  rootUrl: string,
  params: EntiControllerCreateEnte$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<EnteResDto>> {
  const rb = new RequestBuilder(rootUrl, entiControllerCreateEnte.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnteResDto>;
      }),
    );
}

entiControllerCreateEnte.PATH = '/admin/ente';
